import { render } from "./WCAlertCloseButton.vue?vue&type=template&id=7b735444"
import script from "./WCAlertCloseButton.vue?vue&type=script&lang=js"
export * from "./WCAlertCloseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__